import { useEffect } from 'react'
import type { OnChangeFn, RowSelectionState } from '@tanstack/react-table'

interface UseReconcileTaggingSelectionOptions {
  hits: { id: number | string }[]
  setRowSelection: OnChangeFn<RowSelectionState>
}

export const useReconcileTaggingSelection = (
  options: UseReconcileTaggingSelectionOptions,
) => {
  const { hits, setRowSelection } = options

  useEffect(() => {
    setRowSelection(previousSelection => {
      if (Object.keys(previousSelection).length === 0) {
        return previousSelection
      }

      const visibleIds = new Set(hits.map(hit => String(hit.id)))
      const filteredSelection = Object.fromEntries(
        Object.entries(previousSelection).filter(([id]) => visibleIds.has(id)),
      )

      return Object.keys(filteredSelection).length ===
        Object.keys(previousSelection).length
        ? previousSelection
        : filteredSelection
    })
  }, [hits, setRowSelection])
}
